import { PlaceActionType } from './place-action-type';
import { castArray } from 'lodash';

export interface CreatePlaceErrorAction {
  errors: Error[];
  placeKey: string;
  type: PlaceActionType.CreatePlaceError;
}

export const createPlaceError = (
  placeKey: string,
  errors: Error | readonly Error[],
): CreatePlaceErrorAction => ({
  errors: castArray(errors),
  placeKey,
  type: PlaceActionType.CreatePlaceError,
});
